/* eslint-disable jsx-a11y/alt-text */
import { FC } from 'react';

import { TColorProp } from 'styled-components';

import {
  BlinkingImage,
  BlinkingLogoImage,
  SplashLoaderContainer,
} from './styles';
import { Loader } from '../Loader';
import { useCustomTheme } from '../../providers/theme';
import { useBusiness } from '../../providers/business';
import { getBusinessLogo } from '../../constants/vmcore-brand';
import logo from '../../../../public/images/logo.png';

interface IProps {
  loaderColor?: TColorProp;
  showLogo?: boolean;
}

export const SplashLoader: FC<IProps> = ({
  loaderColor = 'primary',
  showLogo = true,
}) => {
  const { business } = useBusiness();
  const { themeOption } = useCustomTheme();
  const businessLogo = getBusinessLogo(
    business,
    themeOption === 'dark' ? 'light' : 'dark'
  );
  const logoAlt = business?.nome || 'logo';

  return (
    <SplashLoaderContainer>
      {showLogo &&
        (businessLogo ? (
          <BlinkingLogoImage alt={logoAlt} src={businessLogo} />
        ) : (
          <BlinkingImage alt={logoAlt} src={logo} objectFit="contain" />
        ))}
      <Loader size={100} type="bar" color={loaderColor} />
    </SplashLoaderContainer>
  );
};
